export enum TabTitleEnum {
  CategoryAll = '전체',
}

export enum BrandDetailListIdEnum {
  BrandDetailList = 'brand-detail-list',
}
